import {Collapse, Tooltip} from "bootstrap";
import {fadeIn, fadeOut} from "helpers/utilities";

// used for displaying the legacy popup windows in Laravel
window.legacyPopup = function (url, name, height, width) {
    window.open(url, name, 'height=' + height + ',width=' + width + ',scrollbars=yes');
}

document.addEventListener("DOMContentLoaded", function () {

    const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]:not(.sidebar-tooltip)');
    [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));

    // Nav burger dropdown
    const navDropElement = document.querySelector('#nav-links-dropdown');

    if (navDropElement) { // only initialize the nav dropdown if it exists on the page
        const navDropdown = Collapse.getOrCreateInstance(navDropElement, {toggle: false});

        // debounce the window resize event to make sure the nav burger is shown correctly.
        function debounce(func, wait) {
            let timeout;
            return function() {
                const context = this;
                const args = arguments;
                clearTimeout(timeout);
                timeout = setTimeout(() => func.apply(context, args), wait);
            };
        }
        function handleResize() {
            navDropdown.hide()
        }
        window.addEventListener('resize', debounce(handleResize, 250));

        // hide the nav dropdown if the user clicks outside of it
        document.querySelector('html').addEventListener('click', () => {
            if (document.querySelector('#nav-links-dropdown').length) {
                navDropdown.hide();
            }
        });

        document.querySelector('#burger-control').addEventListener('click', () => navDropdown.toggle());

        // when the nav link dropdown is shown
        navDropElement.addEventListener('show.bs.collapse', () => {
            document.querySelector('#nav-burger').style.display = "none";
            document.querySelector('#nav-burger-close').style.display = "block";
            fadeIn(document.querySelector("#main-overlay"));
        });

        // when the nav link dropdown is collapsed
        navDropElement.addEventListener('hide.bs.collapse', () => {
            if (window.innerWidth <= 1080) {
                document.querySelector('#nav-burger').style.display = 'block';
                document.querySelector('#nav-burger-close').style.display = 'none';
            } else {
                document.querySelector('#nav-burger').style.display = '';
                document.querySelector('#nav-burger-close').style.display = '';
            }
            fadeOut(document.querySelector("#main-overlay"));
        });
    }
    // END Nav burger dropdown

    // Header dropdowns
    function closeHeaderDropdowns() {
        [...document.querySelectorAll(".header-dropdown-menu")].forEach(menu => {
            menu.classList.remove('show');
        });
    }

    function initializeHeaderDropdown(toggleStr, menuStr) {
        document.querySelector(toggleStr)?.addEventListener('click', e => {
            e.stopPropagation();
            const menu = document.querySelector(menuStr);
            const action = menu.classList.contains('show') ? 'remove' : 'add';
            closeHeaderDropdowns();
            menu.classList[action]('show');
        });
    }

    // Initialize user menu
    initializeHeaderDropdown('#user-dropdown-menu-button', '#user-drop-down-menu');
    // Initialize support menu
    initializeHeaderDropdown('#support-dropdown-menu-button', '#support-drop-down-menu');

    // Close all dropdown menus if the user clicks outside of it
    window.onclick = e => !e.target.matches('.dropdown-toggle')
            && !e.target.matches('#location-switcher-filter')
            && !e.target.matches('.extension-switcher-filter')
            && closeHeaderDropdowns(e);

    // END header dropdowns

    // location switcher dropdown
    document.querySelector('#location-switch-dropdown-toggle')?.addEventListener('click', e => {
        e.stopPropagation();
        const menu = document.querySelector('#location-drop-down-wrapper');
        const action = menu.classList.contains('show') ? 'remove' : 'add';
        closeHeaderDropdowns();
        menu.classList[action]('show');
        document.querySelector('#location-switcher-filter').focus();
    });


    // Customer location name copy-to-clipboard (only works in secure context, i.e. https or localhost)
    [...document.querySelectorAll('.copy-location-to-clipboard')].forEach(btn => btn.addEventListener('click', function () {

        try {
            const text = this.querySelector(".copy-location-to-clipboard-string").value;
            navigator.clipboard.writeText(text).then(
                    () => {
                        /* clipboard successfully set */
                        const copyConf = this.querySelector(".copy-confirmation");
                        copyConf.style.opacity = 1;
                        copyConf.style.display = 'block';
                        setTimeout(function () {
                            fadeOut(copyConf)
                        }, 1000);
                    },
                    () => {
                        /* clipboard write failed */
                        alert("No secure context. Can't copy to clipboard.");
                    },
            );
        } catch {
            alert("No secure context. Can't copy to clipboard.");
        }
    }));

    // plug in the location switcher if we have one
    if (document.querySelector('#location-switch')) {
        // set the total results display
        const resultsDisplay = document.querySelector('#locationSwitcherSearchResults');
        const totalResults = document.querySelector('#location-switch').dataset.total - 1;
        resultsDisplay.innerHTML = `Showing ${totalResults} of ${totalResults}`;

        // filter the results on keyup
        document.querySelector("#location-switcher-filter").addEventListener("keyup", function () {
            const value = this.value.toLowerCase();
            const locations = [...document.querySelectorAll(".location-switcher-item")];
            locations.forEach((el) => {
                el.style.display = el.dataset.bsOriginalTitle.toLowerCase().indexOf(value) === -1
                        ? 'none'
                        : 'block'
            });

            // update the results display
            const newCount = locations.filter(el => el.style.display !== 'none')?.length;
            resultsDisplay.innerHTML = `Showing ${newCount} of ${totalResults}`;
        });
    }

    // hide any temp alerts after 4 seconds
    [...document.querySelectorAll('.temp-alert')]
            .forEach(alert => setTimeout(() => alert.classList.add('d-none'), 4000));
});
